export const Header = {
  PageHeader: 'h1',
  SectionTitle: 'h2'
};
